module.exports = "<button type=\"button\" *ngIf=\"pageName == 'viewRequest'\" (click)=\"socDetailsByReturnOrderId()\" md-raised-button color=\"primary\" class=\"btn-w-md color-white\" style=\"min-width: 90px;min-height: 30px;cursor:pointer\"><i class=\"material-icons color-white dashboard-icon-color\">view_list</i><span class=\"btn-text\">View SOC ID</span></button>\n<a *ngIf=\"pageName == 'dashboard'\" (click)=\"socDetailsByReturnOrderId()\">View </a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/socIdDetails/socIdDetails.component.html
// module id = 991
// module chunks = 10